import { Pipe, PipeTransform } from '@angular/core';
/**
 *  MultiplyBy pipe
 */
@Pipe({ name: 'multiplyBy' })
export class MultiplyByPipe implements PipeTransform {
  /**
   * MultiplyBy pipe
   * @param value Input value (numeric)
   * @param factor Multiply value with factor
   * @param nullable If value is null return null (default)
   */
  transform(value: number, factor: number, nullable = true): number {
    if (nullable && value === null) {
      return null;//in Javascript f.e. null * 100 = 0, but sometimes we want it to be null
    }

    return value * factor;
  }
}
